import { assign } from '@atds-legacy/lang';

export default function startOver(link) {
  if (!link) {
    return '';
  }

  link.query = assign({}, link.query, { startOver: 'true' });
  return link;
}
